// extracted by mini-css-extract-plugin
export default {"text-limit":"client-components-common-___textLimit__text-limit___3XKS9","red":"client-components-common-___textLimit__red___dpfg8"};